import { StandardEnvironment } from "@project/emerge/src/new/StandardEnvironment";

/**
 * Scene without the floor grid, for screenshots that go into a quote.
 *
 * Keeps {@link StandardEnvironment}: it only sets `scene.environment`, which is
 * the lighting and reflection source rather than the visible backdrop. Dropping
 * it to hide the grid would leave the product unlit. Setting and clearing
 * `scene.environment` is the environment's own job — there is no `onCreated`
 * hook to hang extra bookkeeping off.
 */
export const CleanScene = () => <StandardEnvironment isGlobal={true} />;
